import { useState } from "react";
import { Select, CourseSet } from "../../types/requirement.response";
import { DEFAULT_SEMESTER } from "../../constants";
import FilterToggle from "./FilterToggle";
import CourseSetRows from "./CourseSetRows";
import RequirementTabBar from "../shared/RequirementTabBar";
import { ReqDetailBaseProps } from "./types";

interface OptionReqDetailProps extends ReqDetailBaseProps {
    onToggleFilter: () => void;
}

export default function OptionReqDetail({
    programInfo,
    requirement,
    coursesMap,
    isSliceLoaded,
    handleAddCourse,
    handleDeleteCourse,
    handleFavoriteCourse,
    optimisticFavorites,
    userCourses,
    hideUnavailable,
    onToggleFilter,
}: OptionReqDetailProps) {
    const rootNode = requirement.rootNode as Select;
    const children = rootNode.children.filter(
        (child): child is CourseSet => child.type === "COURSE_SET"
    );

    const [activeTab, setActiveTab] = useState(0);
    const activeChild = children[activeTab];

    if (children.length === 0) {
        return (
            <p className="px-4 py-6 text-sm text-gray-400 italic">
                No options found for this requirement.
            </p>
        );
    }

    return (
        <>
            <div className="mt-4">
                <RequirementTabBar
                    items={children}
                    fulfilledIds={rootNode.fulfilledChildIds}
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                />
                <div className="flex justify-end mt-4">
                    <FilterToggle active={hideUnavailable} onToggle={onToggleFilter} semester={DEFAULT_SEMESTER} />
                </div>
            </div>
            <table className="w-full border-collapse">
                <tbody>
                    <CourseSetRows
                        key={activeChild.id}
                        courseSet={activeChild}
                        programInfo={programInfo}
                        coursesMap={coursesMap}
                        isSliceLoaded={isSliceLoaded}
                        requirementId={requirement.info.id}
                        handleAddCourse={handleAddCourse}
                        handleDeleteCourse={handleDeleteCourse}
                        handleFavoriteCourse={handleFavoriteCourse}
                        optimisticFavorites={optimisticFavorites}
                        userCourses={userCourses}
                        hideUnavailable={hideUnavailable}
                        emptyMessage="No courses found in this option."
                    />
                </tbody>
            </table>
        </>
    );
}
